import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled.div`
  padding-top: 200px;
`;

export const AnimateContainer = styled.div`
  position: relative;
`;

export const MotionContainer = styled(motion.div)`
  position: ${({ position }: { position: string }) => position};
  top: 0;
  left: 0;
  width: 100%;
  transform-origin: center top;
`;

export const HiddenBottom = styled.div`
  height: 20px;
  width: 100%;
  background-color: transparent;
`;
